module.exports = __webpack_public_path__ + "media/components/footer/static/tfc--white-43e89220f88186619bef2a3c8904ae84.svg";